module.exports = __webpack_public_path__ + "img/maestro.a257e4fd.png";